import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funkprotokoll-fall-abschliessen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollFallAbschliessenEffects {

    FunkprotokollFallAbschliessen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKPROTOKOLL_FALL_ABSCHLIESSEN),
        mergeMap((x: ac.PostFunkprotokollFallAbschliessenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunkprotokollFallAbschliessen(x.funkprotokollFallRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunkprotokollFallAbschliessenErfolgreichAction(result, x.funkprotokollFallRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunkprotokollFallAbschliessenFehlerAction(error, x.funkprotokollFallRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollCommandService);
        }
        return this.service;
    }
}
